import { createAction } from "redux-smart-actions";
import { takeLatest } from "redux-saga/effects";

import { SagaActionParams, SagaGenericParams } from "../base/types/saga";
import * as Type from "./type";
import { getListSaga } from "../base/request/get";
import { postSaga, PostSagaGenericParams } from "../base/request/post";

export const getFaqs = createAction(
  "GET_FAQS",
  ({ payload, id }: SagaActionParams<Type.FaqsDto[]>) => ({
    payload,
    url: "/api/webadmin/faqs",
  })
);
export const getHowtousecontent = createAction(
  "GET_HOW_TO_USE_CONTENTS",
  ({ payload }: SagaActionParams<Type.HowtoUseContentDto[]>) => ({
    payload,
    url: "/api/webadmin/howtousecontents",
  })
);
export const getPackages = createAction(
  "GET_PACKAGES",
  ({ payload }: SagaActionParams<Type.PackageDto[]>) => ({
    payload,
    url: "/api/webadmin/packages",
  })
);
export const getSectors = createAction(
  "GET_SECTORS",
  ({ payload }: SagaActionParams<Type.SectorDto[]>) => ({
    payload,
    url: "/api/webadmin/sectors",
  })
);

export const getSectorDetails = createAction(
  "GET_SECTOR_DETAILS",
  ({ payload, id }: SagaActionParams<Type.SectorDetailDto>) => ({
    payload,
    url: "/api/webadmin/sectors/" + id,
  })
);
export const getAgreements = createAction(
  "GET_AGREEMENTS",
  ({ payload }: SagaActionParams<Type.AgreementDto[]>) => ({
    payload,
    url: "/api/webadmin/agreements",
  })
);
export const getAgreementDetails = createAction(
  "GET_AGREEMENT_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AgreementDto>) => ({
    payload,
    url: "/api/webadmin/agreement/" + id,
  })
);
export const getWebModules = createAction(
  "GET_WEB_MODULES",
  ({ payload }: SagaActionParams<Type.WebModuleDto[]>) => ({
    payload,
    url: "/api/webadmin/webmodules",
  })
);
export const getWebModulesBySeo = createAction(
  "GET_WEB_MODULES_BY_SEO",
  ({ payload, id }: SagaActionParams<Type.WebModuleDto[]>) => ({
    payload,
    url: "/api/webadmin/webmodulesbyseo/" + id,
  })
);
export const getWebModuleDetailsBySeo = createAction(
  "GET_WEB_MODULE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.WebModuleDto>) => ({
    payload,
    url: "/api/webadmin/webmodules-detailsbyseo/" + id,
  })
);
export const createContact = createAction(
  "CREATE_CONTACT",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/webadmin/contact",
    body: body,
  })
);
const homepageSagas = [
  takeLatest(
    getAgreements.toString(),
    (payload: SagaGenericParams<Type.AgreementDto>) =>
      getListSaga<Type.AgreementDto>(payload)
  ),
  takeLatest(
    getAgreementDetails.toString(),
    (payload: SagaGenericParams<Type.AgreementDto>) =>
      getListSaga<Type.AgreementDto>(payload)
  ),
  takeLatest(getFaqs.toString(), (payload: SagaGenericParams<Type.FaqsDto>) =>
    getListSaga<Type.FaqsDto>(payload)
  ),
  takeLatest(
    getSectorDetails.toString(),
    (payload: SagaGenericParams<Type.SectorDetailDto>) =>
      getListSaga<Type.SectorDetailDto>(payload)
  ),
  takeLatest(
    getHowtousecontent.toString(),
    (payload: SagaGenericParams<Type.HowtoUseContentDto>) =>
      getListSaga<Type.HowtoUseContentDto>(payload)
  ),
  takeLatest(
    getSectors.toString(),
    (payload: SagaGenericParams<Type.SectorDto>) =>
      getListSaga<Type.SectorDto>(payload)
  ),
  takeLatest(
    getWebModules.toString(),
    (payload: SagaGenericParams<Type.WebModuleDto>) =>
      getListSaga<Type.WebModuleDto>(payload)
  ),
  takeLatest(
    getWebModuleDetailsBySeo.toString(),
    (payload: SagaGenericParams<Type.WebModuleDto>) =>
      getListSaga<Type.WebModuleDto>(payload)
  ),
  takeLatest(
    getWebModulesBySeo.toString(),
    (payload: SagaGenericParams<Type.WebModuleDto>) =>
      getListSaga<Type.WebModuleDto>(payload)
  ),
  takeLatest(
    getPackages.toString(),
    (payload: SagaGenericParams<Type.PackageDto>) =>
      getListSaga<Type.PackageDto>(payload)
  ),
  takeLatest(createContact.toString(), (payload: PostSagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
];

export default homepageSagas;
